import { create } from 'zustand'

// The constellation's movable center. null = the ego (the default, and the fallback
// whenever the focused node isn't in the current view). Rings are ALWAYS honest:
// degrees of separation from whoever holds the center.
interface GraphFocusState {
  focusId: string | null
  setFocus: (id: string | null) => void
}

export const useGraphFocus = create<GraphFocusState>((set) => ({
  focusId: null,
  setFocus: (focusId) => set({ focusId }),
}))
